import SearchFilter from '../../components/ui/filters/SearchFilter';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import { dateFormat, isUserCanCreate, isUserCanEdit } from '../../lib/utils';
import { PurchaseOrderStatusEnums } from '../../lib/enums';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DateRangeSelector from '../../components/ui/filters/DateRangeFilter';
import { Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import PrimaryButton from '../../components/ui/PrimaryButton';
import SelectFilter from '../../components/ui/filters/SelectFilter';
import AccreditedFilter from '../../components/ui/filters/AccreditedFilter';
import { initialPurchaseOrderForm } from '../../types/PurchaseOrder';
import { usePurchaseOrderStore } from '../../store/PurchaseOrderStore';
import { useAuthStore } from '../../store';

const PurchaseOrderFilterHeader = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedValue, setSelectedValue] = useState<string | undefined>(
    searchParams.get('status') || PurchaseOrderStatusEnums.ALL,
  );
  const purchaseOrderStore = usePurchaseOrderStore();
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const startDate =
    searchParams.get('start') === undefined ||
    searchParams.get('start') === null
      ? dayjs().subtract(6, 'month').format(dateFormat)
      : searchParams.get('start');

  const endDate =
    searchParams.get('end') === undefined || searchParams.get('end') === null
      ? dayjs().add(2, 'month').format(dateFormat)
      : searchParams.get('end');

  const statusOptions: { value: string; label: string }[] = Object.keys(
    PurchaseOrderStatusEnums,
  ).map(
    (key) =>
      ({
        value:
          PurchaseOrderStatusEnums[
            key as keyof typeof PurchaseOrderStatusEnums
          ],
        label:
          PurchaseOrderStatusEnums[
            key as keyof typeof PurchaseOrderStatusEnums
          ],
      }) as { value: string; label: string },
  );

  const handleChange = (value: string) => {
    setSearchParams((prev) => {
      prev.set('status', value === undefined ? '' : value);
      return prev;
    });
    setSelectedValue(value);
  };

  const isCurrentUserCanCreate = () => {
    return (
      user?.role === 'ROLE_ADMIN' ||
      isUserCanCreate(user?.moduleAccess, 'PurchaseOrder')
    );
  };

  console.log(isCurrentUserCanCreate());

  return (
    <>
      <div className={'flex p-4 justify-between'}>
        <Space>
          <SearchFilter />
          <DateRangeSelector startDate={startDate} endDate={endDate} />
          <SelectFilter
            handleChange={handleChange}
            defaultValue={selectedValue}
            dataOptions={statusOptions}
          />
          {/* Audit view: narrow to POs of accredited suppliers. Defaults to All. */}
          <AccreditedFilter />
        </Space>
        {isCurrentUserCanCreate() && (
          <PrimaryButton
            icon={<PlusOutlined />}
            onClick={() => {
              purchaseOrderStore.setFormData(initialPurchaseOrderForm);
              navigate('/purchase-order/request?action=Create');
            }}
            label={'Create'}
          />
        )}
      </div>
    </>
  );
};

export default PurchaseOrderFilterHeader;
